import {
  DisbursementKind,
  DisbursementType,
  Donation,
  DonationListStatusFilterEnum
} from '@percent/partner-dashboard/services/donation/donationService.types'

export function getDisplayDonationStatus(donation: Pick<Donation, 'disbursement' | 'status'>) {
  if (
    donation.disbursement?.disbursementType === DisbursementType.Cheque &&
    donation.disbursement.disbursementKind === DisbursementKind.InTransit
  ) {
    return DonationListStatusFilterEnum.CheckSent
  }

  return donation.status
}
